import { useFlags } from 'launchdarkly-react-client-sdk'
import { useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'

import { PATHS } from '@/config/router/paths'

export type OffersFormBackTab =
  | 'item_discount'
  | 'cart_discount'
  | 'buyX_getY'

export type OffersFormMode = 'create' | 'edit'

/**
 * After a successful create/edit submit: new campaigns page on create,
 * otherwise the Offers tab that matches `tab`.
 */
export function useOfferFormSuccessNavigate(tab: OffersFormBackTab) {
  const history = useHistory()

  return useCallback(
    (mode: OffersFormMode) => {
      if (mode === 'create') {
        history.replace(PATHS.MARKETING_CAMPAIGNS)
        return
      }
      history.push(generatePath(PATHS.OFFERS_BY_ID, { id: tab }))
    },
    [history, tab]
  )
}

/**
 * Navigate back from create/edit offer flows: Marketing tools page when LD flag is on,
 * otherwise the Offers tab that matches `tab`.
 */
export function useOfferFormNavigateBack(tab: OffersFormBackTab) {
  const history = useHistory()
  const { lmd_store_web_offers_marketing } = useFlags()

  return useCallback(() => {
    if (lmd_store_web_offers_marketing) {
      history.push(PATHS.MARKETING_TOOLS)
      return
    }
    history.push(generatePath(PATHS.OFFERS_BY_ID, { id: tab }))
  }, [history, lmd_store_web_offers_marketing, tab])
}
